<script setup lang="ts">
import RayaCard from '../raya-ui/RayaCard.vue';
withDefaults(defineProps<{
  rounded?: string | number; hoverable?: boolean; variant?: string; color?: string; to?: string; elevated?: boolean; title?: string;
}>(), { rounded: 'lg', variant: 'flat', color: undefined, to: undefined, title: undefined });
defineEmits<{ click: [event: MouseEvent] }>();
</script>
<template>
  <RayaCard
    :to="to"
    :class="['ava-card', { 'ava-card--hoverable': hoverable, 'ava-card--elevated': elevated }]"
    @click="$emit('click', $event)"
  >
    <h2
      v-if="title"
      class="ava-card-title"
    >
      {{ title }}
    </h2><slot />
  </RayaCard>
</template>
